import { render, staticRenderFns } from "./NoAccountNonStudent.vue?vue&type=template&id=3164b82e&"
import script from "./NoAccountNonStudent.vue?vue&type=script&lang=js&"
export * from "./NoAccountNonStudent.vue?vue&type=script&lang=js&"
import style0 from "./NoAccountNonStudent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports